import React from "react";
import "./Hero.css";
import { motion } from "framer-motion";
import { TypeAnimation } from "react-type-animation";
import {
  FaGithub,
  FaLinkedin,
  FaDownload,
  FaArrowRight,
} from "react-icons/fa";
import { portfolioData } from "../../data/portfolioData";

const Hero = () => {
  const { personal } = portfolioData;

  return (
    <section className="hero" id="home">
      {/* Background Radial Ambient Lights */}
      <div className="blur blur-one"></div>
      <div className="blur blur-two"></div>

      <div className="hero-container">
        
        {/* LEFT SIDE: Typography & Actions */}
        <div className="hero-content">
          <motion.div
            className="hero-status-tag"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="pulse-dot"></span>
            AVAILABLE FOR HIRE
          </motion.div>

          <motion.span
            className="hero-greeting"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Hi, I'm
          </motion.span>

          <motion.h1
            className="hero-name"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {personal.name}
          </motion.h1>

          <div className="hero-role-wrapper">
            <TypeAnimation
              sequence={[
                "Full Stack Developer",
                2000,
                "React Developer",
                2000,
                "Angular Developer",
                2000,
                "Node.js Developer",
                2000,
              ]}
              wrapper="h2"
              speed={45}
              repeat={Infinity}
              className="hero-role"
            />
          </div>

          <p className="hero-description">
            I build scalable and performant web applications with modern technologies. 
            Passionate about clean code, problem solving and delivering exceptional user experiences.
          </p>

          <div className="hero-buttons">
            <a href="#projects" className="btn-primary">
              View Projects <FaArrowRight />
            </a>
            <a href="/resume.pdf" className="btn-secondary" download>
              Download Resume <FaDownload />
            </a>
          </div>

          <div className="hero-socials">
            <a href="https://github.com" target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>
        </div>

        {/* RIGHT SIDE: Animated Profile Glow Card */}
        <motion.div
          className="hero-image-section"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          {/* Layered ambient glow blobs underneath */}
          <div className="hero-bg-circle ring-glow-one"></div>
          <div className="hero-bg-circle ring-glow-two"></div>
          
          {/* The main circular card frame */}
          <div className="hero-image-card">
            <div className="hero-image-inner">
              <img
                src={personal.profileImage}
                alt={personal.name}
                className="hero-image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                  display: "block"
                }}
              />
            </div>
          </div>

          {/* Overlay Experience Counter Badge */}
          <div className="experience-badge">
            <h3>2+</h3>
            <p>Years of<br />Experience</p>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;